import { mapActions, mapGetters } from 'vuex'
import { merge, map, get, debounce, cloneDeep, values } from 'lodash'
import md5 from '../helpers/md5'

export default {
    data () {
        return {
            options: {
                currentPage: 1,
                perPage: 20,
                sortDirection: 'asc',
                sortBy: 'id',
            },
            paginator: {
                ids: [],
                total: 0,
            },
            filters: {},
        }
    },
    computed: {
        ...mapGetters({

        }),
        isSetFilter() {
            return values(this.filters).length
        }
    },
    methods: {
        ...mapActions({

        }),
        customFilter(filters) {
            return merge({}, this.options, this.filters, filters)
        },
        sortChange(field, direction) {
            this.options.sortBy = field
            this.options.sortDirection = direction
        },
        filterChange: debounce(function (val) {
            this.filters = merge({}, this.filters, cloneDeep(val))
        }, 280),
        fetchDebounce: debounce(function (val) {
            return this.fetch(val)
        }, 20),
        fetch (filters = {}) {
            return this.fetchItems(this.customFilter(filters)).then((data) => {
                this.paginator.ids = map(get(data, 'data'), 'id')
                this.paginator.total = get(data, 'meta.total', 0)
                this.options.perPage = get(data, 'meta.per_page', this.options.perPage)
            })
        },
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetchDebounce()
            }
        },
        filters: {
            deep: true,
            handler(newVal, oldNew) {
                if (md5(JSON.stringify(newVal)) !== md5(JSON.stringify(oldNew))) {
                    this.fetchDebounce()
                }
            }
        },
    }
}
